module.exports = __webpack_public_path__ + "c411039abd7388206824212750af4cc1.pdf";